import { NgModule } from '@angular/core';
import {
  RouterModule,
  Routes,
} from '@angular/router';
import { IsAnonymousGuard } from '@lib/gc-common';

import { ProfileFeedComponent } from './profile-feed/profile-feed.component';
import { ProfileInfoComponent } from './profile-info/profile-info.component';
import { ProfileInvitationComponent } from './profile-invite/profile-invitation/profile-invitation.component';
import { ProfileInviteComponent } from './profile-invite/profile-invite.component';
import { ProfileRedirectEventComponent } from './profile-redirect-event/profile-redirect-event.component';
import { ProfileStoriesComponent } from './profile-stories/profile-stories.component';
import { ProfileComponent } from './profile.component';

const routes: Routes = [
  {
    path: '',
    component: ProfileComponent,
    children: [
      {
        path: 'info/:tab',
        component: ProfileInfoComponent,
      },
      {
        path: 'invite',
        component: ProfileInviteComponent,
      },
      {
        path: 'invite/:code',
        component: ProfileInvitationComponent,
        canActivate: [IsAnonymousGuard],
      },
    ],
  },
  {
    path: 'p',
    component: ProfileFeedComponent,
    children: [
      {
        path: ':postId',
        children: [
          {
            path: 'c',
            children: [
              {
                path: ':commentId',
                children: [],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: 'stories',
    component: ProfileStoriesComponent,
    data: {
      hideMenuBar: true,
    }
  },
  {
    path: 'invite/:code/experience',
    component: ProfileRedirectEventComponent,
    canActivate: [IsAnonymousGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProfileRoutingModule {
}
